var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5242_44857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 10H9C9.552 10 10 9.553 10 9V3C10 2.448 9.552 2 9 2H3C2.448 2 2 2.447 2 3V9C2 9.552 2.448 10 3 10ZM4 4H8V8H4V4Z",
    fill: "url(#paint0_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2H17C16.448 2 16 2.448 16 3V7C16 7.553 16.448 8 17 8H21C21.552 8 22 7.553 22 7V3C22 2.447 21.552 2 21 2ZM20 6H18V4H20V6Z",
    fill: "url(#paint1_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16H3C2.448 16 2 16.448 2 17V21C2 21.553 2.448 22 3 22H7C7.552 22 8 21.553 8 21V17C8 16.447 7.552 16 7 16ZM6 20H4V18H6V20Z",
    fill: "url(#paint2_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2H11V4H15V2Z",
    fill: "url(#paint3_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9H15V7H13V5H11V8C11 8.552 11.448 9 12 9Z",
    fill: "url(#paint4_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10V14C16 14.553 16.448 15 17 15H20V16H22V14C22 13.448 21.552 13 21 13H18V11H22V9H17C16.448 9 16 9.447 16 10Z",
    fill: "url(#paint5_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15V12C10 11.448 9.552 11 9 11H2V13H4V15H6V13H8V15H10Z",
    fill: "url(#paint6_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13H11V15H15V13Z",
    fill: "url(#paint7_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H12V12H15V10Z",
    fill: "url(#paint8_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18V20H11V19H9V21C9 21.553 9.448 22 10 22H16C16.552 22 17 21.553 17 21V19H22V17H16C15.448 17 15 17.447 15 18Z",
    fill: "url(#paint9_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16H12V19H14V16Z",
    fill: "url(#paint10_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H9V18H11V16Z",
    fill: "url(#paint11_linear_5242_44857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20H18V22H22V20Z",
    fill: "url(#paint12_linear_5242_44857)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5242_44857",
    x1: 2,
    y1: 6,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5242_44857",
    x1: 16,
    y1: 5,
    x2: 22,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5242_44857",
    x1: 2,
    y1: 19,
    x2: 8,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5242_44857",
    x1: 11,
    y1: 3,
    x2: 15,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5242_44857",
    x1: 11,
    y1: 7,
    x2: 15,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5242_44857",
    x1: 16,
    y1: 12.5,
    x2: 22,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5242_44857",
    x1: 2,
    y1: 13,
    x2: 10,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5242_44857",
    x1: 11,
    y1: 14,
    x2: 15,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5242_44857",
    x1: 12,
    y1: 11,
    x2: 15,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5242_44857",
    x1: 9,
    y1: 19.5,
    x2: 22,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5242_44857",
    x1: 12,
    y1: 17.5,
    x2: 14,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5242_44857",
    x1: 9,
    y1: 17,
    x2: 11,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5242_44857",
    x1: 18,
    y1: 21,
    x2: 22,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85B08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5242_44857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletQrcode);
export default __webpack_public_path__ + "static/media/wallet_qrcode.e37260c18b1353624249d23d91759d16.svg";
export { ForwardRef as ReactComponent };